import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/lesson-platform/src/app/components/marketing/MarketingFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/lesson-platform/src/app/components/marketing/MarketingNavigation.tsx");
